import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import MechanicalDesignCriteria from './pages/MechanicalDesignCriteria';
import Drawings from './pages/Drawings';
import Login from './pages/Login';
import AssetDetail from './pages/AssetDetail';
import QrManagement from './pages/QrManagement';
import PlantRoom from './pages/PlantRoom';
import MobileAsset from './pages/MobileAsset';
import ContextualAi from './pages/ContextualAi';
import Search from './pages/Search';
import DemoGuide from './pages/DemoGuide';
import MoreInfo from './pages/MoreInfo';
import HealthSafetyElectrical from './pages/HealthSafetyElectrical';
import { ScrollToTop } from './components/ScrollToTop';
import './styles/global.scss';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/drawings" element={<Drawings />} />
          <Route path="/login" element={<Login />} />
          <Route path="/asset-data/ahu-003" element={<AssetDetail />} />
          <Route path="/asset-data/mechanical/ahu-003" element={<Navigate to="/asset-data/ahu-003" replace />} />
          <Route path="/asset-data/ahu-003/qr" element={<QrManagement />} />
          <Route path="/locations/plant-room-01" element={<PlantRoom />} />
          <Route path="/mobile-asset" element={<MobileAsset />} />
          <Route path="/contextual-ai" element={<ContextualAi />} />
           <Route path="/search" element={<Search />} />
           <Route path="/demo" element={<DemoGuide />} />
           <Route path="/more-info" element={<MoreInfo />} />
          <Route
            path="/design-criteria/mechanical"
            element={<MechanicalDesignCriteria />}
          />
          <Route
            path="/design-criteria"
            element={<Navigate to="/design-criteria/mechanical" replace />}
          />
          <Route
            path="/health-and-safety/electrical"
            element={<HealthSafetyElectrical />}
          />
          <Route
            path="/health-safety/electrical"
            element={<Navigate to="/health-and-safety/electrical" replace />}
          />
          <Route
            path="/hs/electrical"
            element={<Navigate to="/health-and-safety/electrical" replace />}
          />
          <Route
            path="/health-and-safety"
            element={<Navigate to="/health-and-safety/electrical" replace />}
          />
          <Route
            path="/health-safety"
            element={<Navigate to="/health-and-safety/electrical" replace />}
          />
          <Route
            path="/hs"
            element={<Navigate to="/health-and-safety/electrical" replace />}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
